var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPlaceholderFill1(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.06 1.87627C8.41146 1.47093 7.58854 1.47093 6.94 1.87627L2.94 4.37627C2.35524 4.74175 2 5.38269 2 6.07227V9.92761C2 10.6172 2.35524 11.2581 2.94 11.6236L6.94 14.1236C7.58854 14.5289 8.41146 14.5289 9.06 14.1236L13.06 11.6236C13.6448 11.2581 14 10.6172 14 9.92761V6.07227C14 5.38269 13.6448 4.74175 13.06 4.37627L9.06 1.87627Z",
    fill: "#FF502D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlaceholderFill1);
export default __webpack_public_path__ + "static/media/placeholder Fill 1.ab3f65525b42d12124a8a46d00992efc.svg";
export { ForwardRef as ReactComponent };